import type { DriveMode } from "./DriveModeCards.js";

export function driveModeOptionId(mode: DriveMode): string {
  return `persona-set-drive-mode-${mode}`;
}

/** Looks up a radio inside one dialog. Duplicate ids in another open dialog are ignored. */
export function findElementIn(root: ParentNode | null, id: string): HTMLElement | null {
  if (!root || !/^[A-Za-z0-9_-]+$/.test(id)) return null;
  // Attribute selector, not #id: duplicate ids are invalid and #id returns the first in the document.
  return root.querySelector<HTMLElement>(`[id="${id}"]`);
}

/**
 * Restores focus after a mode switch remounts the picker. The pending target is
 * cleared only once a radio is actually focused, so a permission change that
 * hides the requested mode can still focus the control that remains.
 */
export function resolveDriveModeFocusTarget(
  pending: DriveMode | null,
  driveMode: DriveMode,
  findById: (id: string) => HTMLElement | null,
): { pending: DriveMode | null; element: HTMLElement | null } {
  if (!pending) return { pending: null, element: null };

  const requested = findById(driveModeOptionId(pending));
  if (requested) return { pending: null, element: requested };

  if (pending === driveMode) return { pending, element: null };

  const fallback = findById(driveModeOptionId(driveMode));
  if (!fallback) return { pending, element: null };
  return { pending: null, element: fallback };
}
